<template>
  <div class="main-template">
    <!-- <v-form-component
      v-if="modelReady"
      :dataObject="dataObject"
      :schema="currentSchema"
      :model="currentModel"
      class="mb-2 mt-n2 pa-0"
      :compclass="'mb-n4 mt-n2 pa-0'"
      :key="formKey"
    ></v-form-component> -->
    <!-- {{ dataObject }} -->

    <v-form-card
      v-if="modelReady"
      flat
      :dObject="dataObject"
      submit_button_caption="Save"
      :mainTabs="mainTabs"
      :hasParent="true"
    >
    </v-form-card>
  </div>
</template>

<script>
import * as fun from "../plugins/common";

import axios from "axios";

export default {
  name: "Portal",
  components: {
    VFormComponent: () => import("../components/FormComponent.vue"),
    VFormCard: () => import("../components/FormCard.vue")
  },
  props: {},
  data() {
    return {
      formKey: 0,
      modelReady: false,
      currentModel: null,
      currentSchema: null,
      dataObject: {
        object_name: "portal_settings"
      },
      mainTabs: [
        {
          tabName: "Order Structure",
          tabId: 0
        },
        {
          tabName: "Credit Card Information",
          tabId: 1
        },
        {
          tabName: "Drop Box",
          tabId: 4
        },
        {
          tabName: "Misc",
          tabId: 2
        },
        {
          tabName: "Shipment Wizard",
          tabId: 3
        }
      ]
    };
  },
  mounted() {
    this.$root.$on("customBtnClick", function(obj) {
      switch (obj.btn) {
        case "authorize_drop_box":
          axios
            .post(
              this.serverURL + "/get_dropbox_authorization_url",
              {},
              {
                withCredentials: true
              }
            )
            .then(response => {
              var url = response.data;
              window.open(url);
            });
          break;
      }
    });

    var data = {
      object_name: "portal_settings",
      all_records: true
    };
    axios
      .post(this.serverURL + "/get_data", data, {
        withCredentials: true
      })
      .then(response => {
        this.currentModel = response.data.model[0] || {
          _id: fun.guid(),
          order_structure: {},
          credit_card: {}
        };
        this.dataObject.schema = response.data.schema;
        this.dataObject.model = this.currentModel;
        this.currentSchema = response.data.schema.properties;
        this.modelReady = true;
        if (!this.currentModel.order_structure) {
          this.currentModel.order_structure = {};
        }
        if (!this.currentModel.credit_card) {
          this.currentModel.credit_card = {};
        }
        if (!this.currentModel.drop_box) {
          this.currentModel.drop_box = {};
        }
      });
  },
  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="css" scoped></style>
